<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_duplicate_code_title' | translate }}</h4>
  <form #form="ngForm">
    <mat-form-field floatLabel="always">
      <mat-label>{{ 'common_code' | translate }}</mat-label>
      <input matInput [(ngModel)]="code" #codeModel="ngModel" cdkFocusInitial name="code" minlength="2" [maxlength]="data.maxLength" required />
      <mat-hint>{{ 'dialog_duplicate_code_hint' | translate }}</mat-hint>
      <mat-error *ngIf="codeModel.errors?.codeAlreadyExists">{{ 'error_code_already_exists' | translate }}</mat-error>
      <mat-error *ngIf="!codeModel.errors?.codeAlreadyExists">{{ 'ref_error_code_required' | translate }}</mat-error>
    </mat-form-field>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button type="button" mat-button (click)="onSubmit()" color="accent" [disabled]="!form.valid || isSaving">{{ 'common_btn_validate' | translate }}</button>
    </div>
  </form>
</div>
